import { render, staticRenderFns } from "./slideBar.vue?vue&type=template&id=315d428e&scoped=true"
import script from "./slideBar.vue?vue&type=script&lang=js"
export * from "./slideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d428e",
  null
  
)

export default component.exports